function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_38_32",
  "data-name": "Component 38 \\u2013 32",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "data-object",
  d: "M7.888,4.552H33.473L44.059,15.423V52.656H7.888V4.552h24.29V16.517H44.059",
  transform: "translate(-7.888 -4.552)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1804",
  "data-name": "Rectangle 1804",
  width: 27,
  height: 31,
  transform: "translate(28 15.103)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "@",
  transform: "translate(28 38.103)",
  fill: "#ac1ede",
  fontSize: 30,
  fontFamily: "Bahnschrift",
  letterSpacing: "-0.001em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "@")));

var SvgEmailUsage = function SvgEmailUsage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52.104,
    viewBox: "0 0 57 52.104",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailUsage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-usage.41a41456.svg";
export { ForwardRef as ReactComponent };